<template>
  <div class="HardwareProducts">
    <div>
      <div>
        <div>
          <div>智慧医疗云门诊工作站</div>
          <div>患者端设备</div>
          <ul>
            <li>
              通过信息技术与医疗卫生的深度整合，建立覆盖省市县乡村医疗服务机构和个人的市级网络医疗服务平台。
            </li>
            <li>
              实现群众足不出户，不出村也能看病，并能享受县级
              或三甲医院机构的就医水平。
            </li>
          </ul>
        </div>
      </div>
      <div>
        <img src="@/assets/HardwareProducts/shebei1.png" alt="" />
        <div>HR-9000A</div>
      </div>
    </div>
    <div>
      <div>
        <img src="@/assets/HardwareProducts/shebei2.png" alt="" />
        <div>HR-9000A</div>
      </div>
      <div>
        <div>
          <div>智慧医疗云门诊工作站</div>
          <div>医生端设备</div>
          <ul>
            <li>避免因单一判断不足带来的风险，检测指标综合性强。</li>
            <li>专家团队作为技术支持，就医更专业、更快捷。</li>
            <li>数据云端存储，数据链更安全可信。</li>
          </ul>
        </div>
      </div>
    </div>
    <div>
      <div>
        <div>
          <div>智慧医疗云门诊工作站</div>
          <div>豪华版设备</div>
          <ul>
            <li>
              患者可以直接在医院申请复诊，避免重复进医院，消除院内来回跑产生
              的交叉感染机率。
            </li>
            <li>
              同时通过智慧云门诊工作站豪华版，让百姓可自行享受健康管理和慢性
              防治的VIP医疗服务
            </li>
          </ul>
        </div>
      </div>
      <div>
        <img src="@/assets/HardwareProducts/deluxeEdition.png" alt="" />
        <div>HR-9000B(豪华版）</div>
      </div>
    </div>
    <div>
      <div>
        <img src="@/assets/HardwareProducts/homeEdition.png" alt="" />
        <div>HR-J990(家庭版）</div>
      </div>
      <div>
        <div>
          <div>智慧医疗云门诊工作站</div>
          <div>家庭版设备</div>
          <ul>
            <li>在居家环境中提供了便捷的医疗服务。</li>
            <li>
              您可以通过它实现在线挂号、复诊预约，进行高质量的视频就诊，轻松查看检查报告和历史病历，全面了解自身健康状况。
            </li>
            <li>
              设备采用用户友好设计，简单易用，为您带来更智能、高效的医疗体验。
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HardwareProducts",
};
</script>

<style lang="scss" scoped>
@import "index.scss";
</style>